import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonService } from 'src/app-core/services/common.service';
import { AppointmentsService } from 'src/app/appointments/appointments.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';

@Component({
    selector: 'app-appointments-tasks-list',
    templateUrl: './appointments-tasks-list.component.html',
    styleUrls: ['./appointments-tasks-list.component.scss']
})
export class AppointmentsTasksListComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @Output() emitEditAppointment: EventEmitter<any> = new EventEmitter<any>();

    @Input() set appointmentFilterParams(data: any) {
        this.appointmentFilter = data;
        const presentDay = moment();
        this.currentDate = presentDay.format(CommonConstants.appComponent.dateFormat);
        this.month = presentDay.format('MMMM');
        this.lastDay = presentDay.daysInMonth();
        this.year = presentDay.year();
        const test = moment();
        this.onRefreshGridData();
    }

    appointmentFilter: any;
    currentDate: any;
    lastDay: number;
    month: any;
    year: number;
    searchQuery: string;
    isJobsAppointments = false;
    orderId: string;
    searchAppointmentDate = {
        start: moment().subtract(1, 'months').format(),
        end: moment().format()
    };
    dateFormat = CommonConstants.appComponent.dateFormat;
    isFormLoading = false;

    constructor(
        injector: Injector,
        private commonService: CommonService,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private appointmentsService: AppointmentsService,
    ) {
        super(injector);
        if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
            this.isJobsAppointments = false;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
            this.isJobsAppointments = true;
        }
    }

    ngOnInit() {
    }

    onRefreshGridData(): void {
        this.kendogridHelper.sort = [{ dir: 'desc', field: 'appointmentDate' }];
        this.grid.dataStateChange.emit({
            skip: 0,
            take: this.kendogridHelper.defaultRecordsCountPerPage,
            filter: undefined,
            group: undefined,
            sort: this.kendogridHelper.sort,
        });
    }

    getGridRecords(event: DataStateChangeEvent): void {
        if (event) {
            this.kendogridHelper.dataStateChangeEvent(event);
        }
        this.kendogridHelper.showLoadingIndicator();
        this.commonService.getAppointmentGridRecords(event, this.getFilter())
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
                this.kendogridHelper.setGridData(response.data);
                this.kendogridHelper.hideLoadingIndicator();
            });
    }

    getFilter(): any {
        const startDate = moment(this.searchAppointmentDate.start).format(this.dateFormat);
        const endDate = moment(this.searchAppointmentDate.end).format(this.dateFormat);
        let filterQuery = `&IsListView=true&CalenderDate=${startDate}&FromDate=${startDate}&ToDate=${endDate}`;
        if (this.appointmentFilter.orderId) {
            filterQuery += `&IsJob=${this.isJobsAppointments}`;
        }
        if (this.appointmentFilter) {
            if (!this.appointmentFilter.isAllJOb) {
                filterQuery += `&OrderId=${this.appointmentFilter.orderId}`;
            }
            if (this.appointmentFilter.employeeId) {
                filterQuery += `&EmployeeId=${this.appointmentFilter.employeeId}`;
            } else {
                filterQuery += `&EmployeeId=0`;
            }
            if (this.appointmentFilter.appointmentType && this.appointmentFilter.appointmentType.length > 0) {
                let appointmentQuery = '';
                this.appointmentFilter.appointmentType.map(item => appointmentQuery += '&AppointmentTypeIds=' + item).toString();
                filterQuery += appointmentQuery;
            }
            if (this.searchQuery) {
                filterQuery += `&SearchQuery=${this.searchQuery}`;
            }
        }
        return filterQuery;
    }

    editAppointment(dataItem: any) {
        const appointmentData = dataItem;
        appointmentData.start = this.getDateObject(dataItem.appointmentDate, dataItem.startTime);
        appointmentData.end = this.getDateObject(dataItem.appointmentDate, dataItem.endTime);
        appointmentData.jobId = dataItem.displayId;
        appointmentData.orderLongId = dataItem.orderlongId;
        this.emitEditAppointment.emit(dataItem);
    }


    getDateObject = (appointmentDate: string, timeSpan: string) => {
        const eventDate = new Date(appointmentDate);
        const time = timeSpan.split(':');
        eventDate.setHours((+time[0]));
        eventDate.setMinutes((+time[1]));
        eventDate.setSeconds((+time[2]));
        return new Date(eventDate);
    }

    onGetDateFromString(date: string) {
        return this.commonService.getDateObjectFromTimeString(date);
    }

    getEventType(eventType: string) {
        this.appointmentsService.getEventType(eventType);
    }

    onClearSearch(): void {
        this.searchQuery = '';
        this.onRefreshGridData();
    }

    onSearch(): void {
        if (this.searchQuery) {
            this.onRefreshGridData();
        }
    }

    onSearchChange(): void {
        if (!this.searchQuery) {
            this.onRefreshGridData();
        } else if (this.searchQuery.length > 2) {
            this.onRefreshGridData();
        }
    }

    onChangeDate(event: any, type: string, value: any) {
        setTimeout(() => {
            value = moment(event.value).format();
            const start = moment(this.searchAppointmentDate.start).format();
            const end = moment(this.searchAppointmentDate.end).format();
            if (type === CommonConstants.appComponent.start && start > end) {
                this.toastr.error(CommonConstants.appComponent.fromCanNotBeGreaterThenTo);
                this.searchAppointmentDate.start = moment(end).subtract(1, 'months').format();
                return;
            } else if (type === CommonConstants.appComponent.end && end < start) {
                this.toastr.error(CommonConstants.appComponent.toDateCanNotBeLessThenFrom);
                this.searchAppointmentDate.end = moment(start).add(1, 'months').format();
                return;
            }
        });
    }

    onRemove(dataItem: any) {
        this.commonService.getConfirmationPopup
            (CommonConstants.appointmentFormConstant.removeAppointmentConfirmation,
                CommonConstants.appComponent.cancel,
                CommonConstants.appComponent.confirm).then(result => {
                    if (result) {
                        const requestBody = {
                            appointmentId: dataItem.appointmentId,
                            isActive: false
                        };
                        this.isFormLoading = true;
                        this.commonService.deleteAppointment(requestBody)
                            .pipe(finalize(() => (this.isFormLoading = false)))
                            .subscribe((response: any) => {
                                if (response.isSuccess) {
                                    this.toastr.success(response.errors || CommonConstants.appointmentFormConstant.appointmentRemovedSuccessfully);
                                    this.onRefreshGridData();
                                } else {
                                    this.toastr.error(
                                        response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                                }
                                this.isFormLoading = false;
                            });
                    }
                });
    }

    onGetAppointmentList() {
        this.onRefreshGridData();
    }

}
